<script>
import InfoCards from "@js/components/Sections/InfoCards/Components/InfoCards.vue";
import rocket_svg from '@img/guarantee/rocket.svg';
import dollar_svg from '@img/guarantee/dollar-sign.svg';
import star_svg from '@img/guarantee/star.svg';
import certificate_svg from '@img/guarantee/certificate.svg';
import handshake_svg from '@img/guarantee/handshake.svg';
import production_svg from '@img/guarantee/production.svg';

export default {
    name: "WhyWeFirst",
    components: {InfoCards},
    data() {
        return {
            items_group_1: [
                {
                    logo: star_svg,
                    title: 'Высокое качество продукции',
                    description: 'Мы производим бетонные плиты и ЖБИ конструкции, которые соответствуют стандартам ГОСТ. Наша продукция проходит многоуровневый контроль качества, что гарантирует её прочность, долговечность и устойчивость к внешним воздействиям.',
                },
                {
                    logo: production_svg,
                    title: 'Собственное производство',
                    description: 'Вся продукция изготавливается на современном оборудовании с использованием сертифицированных материалов. Благодаря собственному производству мы предлагаем конкурентоспособные цены и контролируем каждый этап изготовления.',
                },
                {
                    logo: rocket_svg,
                    title: 'Быстрая и надежная доставка',
                    description: 'Организуем доставку бетонных плит и ЖБИ конструкций по вашему адресу точно в согласованные сроки. Собственный автопарк и опытные водители гарантируют безопасную транспортировку продукции без повреждений.',
                }
            ],
            items_group_2: [
                {
                    logo: dollar_svg,
                    title: 'Прозрачное ценообразование',
                    description: 'Мы предлагаем честные цены без скрытых доплат. Перед оформлением заказа вы получаете полную смету, чтобы заранее спланировать бюджет. Для оптовых покупателей действуют скидки и специальные условия.',
                },
                {
                    logo: handshake_svg,
                    title: 'Индивидуальный подход',
                    description: 'Наши специалисты всегда готовы помочь вам с выбором продукции, расчетом необходимого объема и подбором оптимального решения для вашего проекта. Мы учитываем все нюансы, чтобы предложить то, что идеально подойдет для ваших нужд.',
                },
                {
                    logo: certificate_svg,
                    title: 'Гарантия на продукцию',
                    description: 'Мы предоставляем гарантию на все бетонные плиты и ЖБИ изделия. Это подтверждает уверенность в их качестве и надежности. Вы можете быть уверены, что наша продукция прослужит долгие годы.',
                }
            ],
        }
    }
}
</script>

<template>
    <InfoCards :title="'Почему работают с нами: 6 причин выбрать нашу компанию'"
               :items_group_1="items_group_1"
               :items_group_2="items_group_2"/>
</template>

<style scoped lang="scss">

</style>
